export const collaboration = {
  "sharedList": {
    "tabTitleByYou": "Shared by me",
    "tabTitleByOther": "Shared by others",
    "tabTitleBySharerName": "Shared by {name}",
    "downloadFailed": "Failed to download the document.",
    "uploadFailed": "Failed to upload the document.",
    "guest": "Guest",
    "unsharedStatus": "Stopped",
    "commentStatus": "{commentCount} of {memberCount} commented",
    "searchDocuments": "Search documents",
    "listView": "List View",
    "imageView": "Image View",
    "toEuInstance": "Go to EU INSTANCE",
    "toCaInstance": "Go to CA INSTANCE",
    "Owner": "(Owner)",
    "CanView": "(Can view)",
    "CanComment": "(Can comment)",
    "SharedTable": {
      "tableHeaderTitle": {
        "Name": "Name",
        "People": "Participants",
        "Status": "Status",
        "LastActivity": "Last Activity"
      },
      "TeamsIconToolTip": "The document comes from Microsoft Teams",
      "Recent": "Recent",
      "Clear": "Clear"
    },
    "Error": {
      "emailExists": "The email address you typed exists in the sharing list.",
      "email": "The input is not valid!",
      "fileLinkEmpty": "File link missing",
      "hasShared": "The document has been shared on another instance, please try again with resharing with the original version of the document."
    },
    "SharedThumbnail": {
      "EmptyMsg": "No Data"
    },
    "SharedBulkOperation": {
      "UnsharedFile": "Stop Sharing",
      "DeleteSharedFile": "Delete Shared Files",
      "RemoveMe": "Remove Me"
    },
    "SharedUserList": {
      "popTitle": "people",
      "SuccessText": "Successfully added",
      "searchPlaceholder": "Enter email address...",
      "AddBtn": "Add",
      "InviteBtn": "Invite people",
      "userIdentity": "INITIATOR",
      "userNoOpen": "Not opened",
      "userOpened": "Opened",
      "userCommented": "Last commented",
      "People": "People"
    },
    "SharedTableAction": {
      "DueBy": "Due by",
      "timeTitle": "Shared on",
      "AddDeadlineBtn": "Add deadline",
      "CopyLinkBtn": "Copy Shared Link",
      "RemoveBtn": "Remove Me",
      "ShareEmail": "Share with Email",
      "UnsharedBtn": "Stop Sharing",
      "UnshareFileBtn": "Unshare File",
      "DownloadBtn": "Download File",
      "DeleteBtn": "Delete File",
      "ConfirmModalTitle": "Foxit PDF Editor",
      "ConfirmModalTitleOnReader": "Foxit PDF Reader",
      "avtiveText": "{commentCount} of {memberCount} opened",
      "acitveItemCreate": "Created By",
      "CommentedFile": "Commented file",
      "CreatedFile": "Created file",
      "OpenedFile": "Opened file",
      "NotOpenedFile": "Not opened file",
      "modelDeleteContent": "The document will be removed from the shared list. Do you want to continue?",
      "modelUnsharedContent": "This document will no longer be shared. Do you want to continue?",
      "modelRemoveMeContent": "If you remove yourself, this file will be removed from your list of shared files. Do you want to continue?",
      "modelUnsharedDeleteFileContent": "The document will be removed from the shared list. Do you want to continue?",
      "modelCancelBtnText": "Cancel",
      "modelConfirmBtnText": "Continue",
      "modelDeleteConfirmBtnText": "Continue",
      "modelUnsharedConfirmBtnText": "Continue",
      "modelRemoveMeConfirmBtnText": "Remove",
      "modelDeadlineSecondsTitle": "Prompt",
      "modelDeadlineSecondsConfirmBtnText": "OK",
      "moreActive": "Activities",
      "cancelDateTime": "Cancel",
      "removeDateTime": "Remove",
      "deleteDateTime": "Delete",
      "sendSuccessful": "Sent successfully",
      "sendFailed": "Failed to send"
    },
    "DownloadDlg": {
      "titleEditor": "Foxit PDF Editor",
      "titleReader": "Foxit PDF Reader",
      "content": "To open the file in {type}, please make sure you have installed the latest version.",
      "confirmBtn": "Download Now",
      "cancelBtn": "Cancel",
      "openBtn": "Open"
    },
    "ShareEmpty": {
      "title": "No shared document(s)",
      "CloudDataBackup": "Cloud data backup",
      "RealTimeSync": "Real-time Sync",
      "CrossDeviceSync": "Cross-device Sync"
    },
    "DisableStorageShareEmpty": {
      "Title": "No shared document(s)",
      "Desc": "Documents you collaborate with using PDF Editor Cloud in third-party applications will be displayed."
    }
  },
  "Dlg": {
    "noPermission": "You don't have permission to initiate a collaboration, because the document doesn't allow commenting.",
    "stopShare": "The shared document has been removed. Please contact the owner.",
    "reachDeadline": "The sharing of this document has expired, so you will not be able to view shared comments. If you have any questions, please contact the owner.",
    "FileOverSizeCommon": "The size of the file can't be greater than {fileSize} MB",
    "CopySuccessful": "Copied Successfully",
    "success": "success",
    "FileExceededSize": "The size of the file can't be greater than {fileSize}MB, please choose another one and try again.",
    "WelcomeFoxit": "Welcome to Foxit PDF Editor!",
    "SignInCollaborate": "Sign in to collaborate on this file.",
    "SignIn": "Sign In",
    "FileNotExist": "The document has stopped sharing. You can view it in Documents."
  },
  "alertNotification": {
    "last_6h": "\"{FileName}\" will be expired in 6 hours.<br/>Please review and add comments if needed before the deadline.",
    "last_5m": "\"{FileName}\" will be expired in 5 minutes.<br/>Please review and add comments if needed before the deadline."
  },
  "Error": {
    "hasShared": "The document has been shared on another instance, please try again with resharing with the original version of the document.",
    "noPermission": "You don't have permission to share the document, please contact the owner of the docuement for help.",
    "limitOnInvite": "You can't invite more than {limitNum} persons in one document, please remove and re-invite.",
    "limitOnJoin": "The session you're about to join is reached the maximum capacity, please contact the owner of the document.",
    "portfolioNotSupport": "Sorry, the pdf portfolio doesn't support sharing.",
    "operationCancelled": "Network error, operation cancelled"
  },
  "OpenInFoxitPDFEditor": "Open in Foxit PDF Editor",
  "OpenInFoxitPDFReader": "Open in Foxit PDF Reader",
  "OpenInFoxit": "Open in Foxit"
}